<template>
  <el-form :model="form" label-width="20px">
    <el-form-item>
      <el-input
        v-model="form.remark"
        type="textarea"
        show-word-limit
        maxlength="1000"
        :rows="4"
      ></el-input>
      <div style="text-align: right">
        <el-checkbox
          v-model="uploadImageSwitch"
          @change="(val) => uploadSwitchChange(val, 'IMAGE')"
          >上传图片</el-checkbox
        >
        <el-checkbox
          v-model="uploadFileSwitch"
          @change="(val) => uploadSwitchChange(val, 'FILE')"
          >上传文件</el-checkbox
        >
      </div>
    </el-form-item>
    <el-form-item v-if="uploadImageSwitch == true">
      <work-order-image-upload
        :list.sync="form.attachments"
        ref="uploadImage"
        :mini="true"
      ></work-order-image-upload>
    </el-form-item>
    <el-form-item v-if="uploadFileSwitch == true">
      <work-order-file-upload
        :list.sync="form.attachments"
        :max-size="500"
        ref="uploadFile"
      ></work-order-file-upload>
      <template v-if="showAttachmentsExpDate()">
        <el-date-picker
          style="margin-right: 10px; width: 180px"
          size="mini"
          v-model="form.attachmentsExpDate"
          type="datetime"
          placeholder="附件有效截止日期"
          align="right"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
        <el-tooltip class="item" effect="dark" placement="top-start">
          <div slot="content">
            若不填写日期，附件将默认永久有效，可随时查看和下载；
            <br />若填写具体日期，附件将在该日期后自动失效，届时无法从界面上进行查看或下载。
          </div>
          <i class="el-icon-question"></i>
        </el-tooltip>
      </template>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "workOrderEditor",
  props: {
    configAttachmentsExpDate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        remark: "",
        attachments: [],
      },
      text: "",
      editorOption: {
        placeholder: "请输入正文内容，不超过1000字",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ script: "sub" }, { script: "super" }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            ["clean"],
          ],
        },
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "一天后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "三天后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一月后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", date);
            },
          },
        ],
        disabledDate: (time) => {
          // 计算今天0点的时间戳
          const today = new Date();
          today.setHours(0, 0, 0, 0);

          // 返回true表示禁用该日期：所有小于今天0点的日期都被禁用
          return time.getTime() < today.getTime();
        },
      },
      uploadImageSwitch: false,
      uploadFileSwitch: false,
    };
  },
  deactivated() {
    this.form = {
      remark: "",
      attachments: [],
    };
  },
  methods: {
    handleChange({ quill, html, text }) {
      const textLimit = 1000;
      if (text.length <= textLimit) {
        this.text = text;
        this.form.remark = html;
      } else {
        const range = quill.getLength();
        quill.deleteText(textLimit, range);
      }
      this.quillLength = quill.getLength() - 1;
    },
    getData() {
      return this.form;
    },
    clearData() {
      // this.form = this.$options.data().form;
      if (this.$refs.uploadFile) {
        this.$refs.uploadFile.clearData();
      }
      if (this.$refs.uploadImage) {
        this.$refs.uploadImage.clearData();
      }
      this.form.attachments = [];
      this.form.remark = "";
    },
    uploadSwitchChange(val, type) {
      if (val === false) {
        clearAttachments(type);
      }
    },
    clearAttachments(type) {
      if (this.form.attachments && this.form.attachments.length > 0) {
        const filteredItems = this.form.attachments.filter(
          (item) => item.attachmentType !== type
        );
        this.form.attachments = filteredItems;
      }
    },
    showAttachmentsExpDate() {
      return (
        this.configAttachmentsExpDate &&
        this.form.attachments &&
        this.form.attachments.length > 0 &&
        this.form.attachments.some((item) => item.attachmentType === "FILE")
      );
    },
  },
};
</script>

<style lang="less" scoped>
.editor {
  /deep/ .ql-editor {
    height: 200px;
  }
}
</style>
